import script from "./AddCalendarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddCalendarView.vue?vue&type=script&setup=true&lang=ts"

import "./AddCalendarView.vue?vue&type=style&index=0&id=81b3e02e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81b3e02e"]])

export default __exports__